import React from 'react';
import classNames from 'classnames';

interface AnimatedCheckmarkProps {
  animated?: boolean;
  delayed?: boolean;
}

export const AnimatedCheckmark: React.FC<AnimatedCheckmarkProps> = (props) => {
  const { animated = false, delayed = false } = props;

  if (!animated) {
    return (
      <svg width={16} height={16} viewBox={'0 0 16 16'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
        <path
          d={'M4.6665 8.6L6.76174 11L11.9998 5'}
          stroke={'#17C964'}
          strokeWidth={'2'}
          strokeLinecap={'round'}
          strokeLinejoin={'round'}
        />
      </svg>
    );
  }

  return (
    <svg
      width={16}
      height={16}
      viewBox={'0 0 16 16'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
      className={classNames('checkmark', { delayed })}
    >
      <circle cx={'8'} cy={'8'} r={'7'} className={'circle'} />
      <path d={'M4.6665 8.6L6.76174 11L11.9998 5'} className={'path'} />
    </svg>
  );
};
